import React, { FC } from 'react';
import './moneyFooter.module.scss';
import IconLine from './images/sns-icon-line.png';
import IconIg from './images/sns-icon-ig.png';
import IconTwitter from './images/sns-icon-twitter.png';
import LikesLogo from './images/likes-logo-white.png';
import MulticreatorLogo from './images/multicreatorcourse-logo-white.svg';
import MoneyLogo from './images/money-logo.svg';
import BeautyLogo from './images/beauty-logo-white.png';

const MoneySection: FC = () => (
  <div styleName="money-section">
    <a href="https://money.shelikes.jp">
      <div styleName="logo">
        <img src={MoneyLogo} />
      </div>
    </a>
  </div>
);

const PrSection = () => (
  <div styleName="pr-section">
    <div styleName="pr-section-text1">法人様・メディア関係者様</div>
    <div styleName="pr-section-text2">下記メールアドレスまでご連絡ください。</div>
    <div styleName="pr-section-text3">pr@she-inc.co.jp</div>
  </div>
);

const SnsSection: FC = () => (
  <div styleName="sns-section">
    <div styleName="follow-us">FOLLOW US</div>
    <div styleName="sns-icons">
      <div styleName="icon-wrapper">
        <a href="https://lin.ee/CxUxoly" target="_blank">
          <img src={IconLine} width="50" height="50" />
        </a>
      </div>
      <div styleName="icon-wrapper">
        <a href="https://www.instagram.com/shemoney_jp/" target="_blank">
          <img src={IconIg} width="50" height="50" />
        </a>
      </div>
      <div styleName="icon-wrapper">
        <a href="https://twitter.com/SHEmoney_jp" target="_blank">
          <img src={IconTwitter} width="50" height="50" />
        </a>
      </div>
    </div>
  </div>
);

const OfficialLinks = () => (
  <div styleName="official-links">
    <a href="https://she-inc.co.jp/about" target="_blank">
      運営会社
    </a>
    <span styleName="separator">|</span>
    <a href="https://she-inc.co.jp/common/agreement.html?agreement_type=shemoney" target="_blank">
      利用規約
    </a>
    <span styleName="separator">|</span>
    <a href="https://money.shelikes.jp/#plan">料金プラン</a>
    <span styleName="separator">|</span>
    <a href="https://she-inc.co.jp/common/policy.html" target="_blank">
      プライバシーポリシー
    </a>
    <span styleName="separator">|</span>
    <a
      href="https://she-files-public.s3.ap-northeast-1.amazonaws.com/money_%E7%89%B9%E5%AE%9A%E5%95%86%E5%8F%96%E5%BC%95%E6%B3%95%E3%81%AB%E5%9F%BA%E3%81%A4%E3%82%99%E3%81%8F%E8%A1%A8%E7%A4%BA.pdf"
      target="_blank"
    >
      特定商取引法に基づく表示
    </a>
    <span styleName="separator">|</span>
    <a href="mailto:shemoney@she-inc.co.jp?subject=【SHEmoney】お問い合わせ" target="_blank">
      お問い合わせ
    </a>
  </div>
);

const Footest = () => (
  <>
    <div styleName="footest">
      <div styleName="copyright">© SHE inc. All Rights Reserved</div>
      <div styleName="footest-links">
        <div styleName="link">
          <a href="https://shelikes.jp/" target="_blank">
            <img src={LikesLogo} width={'73'} />
          </a>
        </div>
        <div styleName="link">
          <a href="https://shelikes.jp/multicreator/" target="_blank">
            <img src={MulticreatorLogo} width="123" />
          </a>
        </div>
        <div styleName="link">
          <a href="https://beauty.shelikes.jp/" target="_blank">
            <img src={BeautyLogo} width="73" />
          </a>
        </div>
      </div>
    </div>
  </>
);

type FooterProps = {
  id?: string;
};

export const MoneyFooter = ({ id }: FooterProps) => (
  <div styleName="footer" id={id}>
    <div styleName="footer-top">
      <MoneySection />
      <PrSection />
      <SnsSection />
    </div>
    <OfficialLinks />
    <Footest />
  </div>
);
